import { Row, Col, Button, Modal, Collapse, Empty, Divider } from "antd";
import UseStructuredResults from "../hooks/useStructuredResults";
import { useTranslation } from "react-i18next";

const { Panel } = Collapse;

const StructuredResults = ({ laboratoryData, admissionPatientId, branchOfficeId }) => {
  const useStructuredResults = UseStructuredResults();
  const { t, i18n } = useTranslation();

  const bupaOrder = laboratoryData?.find(item => item.provider === "Bupa");
  const bionetOrder = laboratoryData?.find(item => item.provider === "Bionet");
  const sofsaludOrder = laboratoryData?.find(item => item.provider === "Sofsalud");

  const getExamPanels = (order) => {
    if (!order || !order.exams) return [];

    const resultsByCode = {};
    if (order.results && Array.isArray(order.results)) {
      order.results.forEach(result => {
        resultsByCode[result.examCode] = result;
      });
    }

    return order.exams.map((exam, index) => {
      const result = resultsByCode[exam.code];
      return (
        <Panel
          responsive
          key={`exam-${exam.code}`}
          className="collapse-bar"
          header={
            <p className="collapse-title-action mb-0">
              {index + 1}. {exam.name?.toUpperCase()}
            </p>
          }
        >
          <Col lg={24} xs={24} className="panel-items">
            {result ? (
              mapData(result)
            ) : (
              <Row justify='center'>
                <Col lg={21} xs={24}>
                  <Row justify='center'>
                    <Col lg={12} xs={24}>
                      <p className="mb-5">
                        <strong className="bold">Código:</strong> &nbsp; {exam.code}
                      </p>
                    </Col>
                    <Col lg={12} xs={24}>
                      <p className="mb-5">
                        <strong className="bold">Nombre:</strong> &nbsp; {exam.name}
                      </p>
                    </Col>
                    <Divider className="m-10" />
                    <Col lg={24} xs={24}>
                      <p className="mt-5">Resultados pendientes</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
        </Panel>
      );
    });
  };

  const mapData = (logsData) => (
    <Row justify='center'>
      <Col lg={21} xs={24}>
        <Row justify='left'>
          {Object.keys(logsData).map((key, index) => {
            if (!i18n.exists(`laboratory.results.${key}`)) return null;
            const value = logsData[key];
            const translation = t(`laboratory.results.${key}`);
            if (typeof value !== "object" || value === null) {
              return (
                <Col lg={12} xs={24} key={index}>
                  <p className="mb-5">
                    <strong className="bold">{translation}:</strong> &nbsp; {value === null || value === undefined || value === '' ? '-' : value}
                  </p>
                </Col>
              );
            }
            return (
              <Col lg={24} xs={24} key={index}>
                <Divider />
                <Row justify='center'>
                  <Col lg={24} xs={24}>
                    <p className="primary">
                      <strong className="bold">{translation}</strong>
                    </p>
                  </Col>
                  {(Array.isArray(value) ? value : []).map((log, index) => (
                    <Col lg={24} xs={24} key={index}>
                      {index > 0 && <Divider />}
                      <Row justify='center'>
                        <Col lg={24} xs={24}>
                          <p className='analyte-title'>{log.name?.toUpperCase() || '-'}</p>
                        </Col>
                        <Col lg={23} xs={23}>
                          <Row>
                            {Object.keys(log).map((item, _index) => {
                              if (!i18n.exists(`laboratory.results.${item}`)) return null;
                              const itemTranslation = t(`laboratory.results.${item}`);
                              return (
                                <Col lg={12} xs={22} key={_index}>
                                  <p className="mb-5">
                                    <strong className="bold">{itemTranslation}</strong>: &nbsp; {(log[item] === null || log[item] === undefined) ? '-' : (item === 'date' ? useStructuredResults.dateTranslation(log[item]) : log[item])}
                                  </p>
                                </Col>
                              );
                            })}
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  ))}
                </Row>
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );

  const renderProviderOrder = (order, providerName) => {
    if (!order) return null;
    return (
      <Col lg={24} xs={24} className="mb-30">
        <Col lg={24} xs={24} className="mb-10 pl-15 pr-15 pt-15 pb-10 lab-order-info">
          <p className="mb-5"><strong>Laboratorio:</strong> {providerName}</p>
          <p className="mb-5"><strong>Orden:</strong> {order.orderId || order.orderID}</p>
          <p className="mb-5"><strong>Creación:</strong> {useStructuredResults.dateTranslationShort(order.createdAt)}</p>
          <p className="mb-5"><strong>Última actualización:</strong> {useStructuredResults.dateTranslationShort(order.updateAt)}</p>
        </Col>
        {order.exams && order.exams.length > 0 ? (
          <Collapse
            responsive
            accordion
            bordered={false}
            start="right"
            className="mt-10"
          >
            {getExamPanels(order)}
          </Collapse>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <p className="text-center">No hay exámenes solicitados</p>
            }
            className="mt-40"
          />
        )}
      </Col>
    );
  };

  return (
    <Row>
      <Col lg={24} xs={24}>
        <Button
          className="cmt-button secondary mb-10"
          type="primary"
          onClick={() => useStructuredResults.setShowModal(true)}
        >
          Detalle y resultados
        </Button>
        {(bupaOrder && bupaOrder.results && bupaOrder.results.length > 0) && (
          <Button
            className="cmt-button secondary outline mb-10"
            type="primary"
            onClick={() =>
              useStructuredResults.handleDownloadDocument(
                bupaOrder.admissionPatientId
              )
            }
          >
            Descargar PDF
            <span className="icon-system-download ml-5" />
          </Button>
        )}
        <Modal
          className="history-modal structured-results-modal"
          responsive
          centered
          open={useStructuredResults.showModal}
          onCancel={() => useStructuredResults.setShowModal(false)}
          footer={false}
        >
          <Row className="p-lg-20 p-xs-10">
            <Col lg={24} xs={24}>
              <h3 className="text-center mb-20 primary" style={{ fontSize: '24px' }}>Detalle y resultados de laboratorio</h3>
              {admissionPatientId && branchOfficeId && (
                <Row justify="end" className="mb-30">
                  <Col>
                    <Button
                      className="cmt-button secondary"
                      type="primary"
                      size="medium"
                      loading={useStructuredResults.loading.orderRequest}
                      onClick={() => useStructuredResults.handleRequestOrder(admissionPatientId, branchOfficeId)}
                    >
                      Solicitar orden
                    </Button>
                  </Col>
                </Row>
              )}
              {(!laboratoryData || laboratoryData.length === 0 || (!bupaOrder && !bionetOrder && !sofsaludOrder)) ? (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <p className="text-center m-0">No hay órdenes de laboratorio</p>
                  }
                  className="mt-50"
                />
              ) : (
                <>
                  {bupaOrder && renderProviderOrder(bupaOrder, "Bupa")}
                  {bionetOrder && renderProviderOrder(bionetOrder, "Bionet")}
                  {sofsaludOrder && renderProviderOrder(sofsaludOrder, "Sofsalud")}
                </>
              )}
            </Col>
          </Row>
        </Modal>
      </Col>
    </Row>
  );
};

export default StructuredResults;